import Vue from 'vue'
import VueRouter from 'vue-router'

// 导入测试组件
// 导入其他组件
import download from '@/views/download/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/download'
  },
  {
    path: '/download',
    component: download
  }
]

const router = new VueRouter({
  routes
})

export default router
